export interface ProductFeaturesResponse {
  productFeatures: string
}

export enum ProductFeature {
  Aether = 'aether',
}
